import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { articlesOfCategory, type FaqCategoryId } from '../data/faqCatalog';
import { FaqArticleItem } from './FaqArticleItem';
import styles from './FaqCategorySection.module.css';

interface FaqCategorySectionProps {
  categoryId: FaqCategoryId;
  expandedIds: ReadonlySet<string>;
  onToggle: (articleId: string) => void;
  /** Статья, открытая по внутреннему deep-link'у, — если она в этой категории. */
  deepLinkArticleId: string | null;
  deepLinkRef: RefObject<HTMLDivElement>;
}

// PARA-133 (AC-2) — одна категория: локализованный заголовок + её статьи в
// порядке каталога. Состав приходит из faqCatalog.ts, тексты — из i18n (AD-6):
// ни списка статей, ни пользовательского текста в этом файле нет.
export function FaqCategorySection({
  categoryId,
  expandedIds,
  onToggle,
  deepLinkArticleId,
  deepLinkRef,
}: FaqCategorySectionProps): JSX.Element {
  const { t } = useTranslation('faq');

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>{t(`categories.${categoryId}`)}</h2>
      {articlesOfCategory(categoryId).map((article) => (
        <FaqArticleItem
          key={article.id}
          article={article}
          isExpanded={expandedIds.has(article.id)}
          onToggle={onToggle}
          itemRef={article.id === deepLinkArticleId ? deepLinkRef : undefined}
        />
      ))}
    </section>
  );
}
